module.exports = __webpack_public_path__ + "img/dummy475x490.8f135c9b.png";